import { useEffect, useState } from 'react';
import { getStaffPass } from '@generated/hooks/staffPass';
import { getStarsReport } from '@generated/server/stars';
import { StarsBallot } from '@generated/components/StarsBallot';

type Report = Awaited<ReturnType<typeof getStarsReport>>;

/** Staff page: the printable 5 × 7 Red Hook Stars final ballot. */
export function BallotPage() {
  const [r, setR] = useState<Report | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    let on = true;
    getStarsReport({ data: { pass: getStaffPass() } }).then((x) => { if (on) setR(x ?? null); })
      .catch((e) => { console.error(e); if (on) setError('The ballot could not be loaded. Please try again.'); })
      .finally(() => { if (on) setLoading(false); });
    return () => { on = false; };
  }, []);
  if (loading) return <div className="flex gap-6"><div className="h-[672px] w-[480px] max-w-full animate-pulse bg-muted" /><div className="hidden h-[672px] w-[480px] animate-pulse bg-muted md:block" /></div>;
  if (error || !r) return <p role="alert" className="text-sm text-destructive">{error ?? 'The ballot could not be loaded.'}</p>;
  return <StarsBallot r={r} page />;
}
